module.exports = __webpack_public_path__ + "img/f9.cf46d5af.jpg";